import React from 'react';

const ThirdSection = () => {
  return (
    <div className="flex flex-col p-4 md:flex-row md:mt-16 md:items-center md:mx-10 md:p-6">
      <div>
        <img className="m-auto w-2/3" src="images/aboutUs.png" alt="" />
      </div>
      <div>
        <div className="mb-4 md:text-4xl font-semibold md:w-4/6 md:mb-10">
          We'd love to hear from you
        </div>
        <div className="mb-4 md:mb-10">
          Reviews provide an opportunity for businesses and customers to build a
          relationship with one another. Reviews not only have the power to
          influence consumer decisions but can strengthen our credibility.
          Reviews have the power to gain customer trust, and they encourage
          people to interact with us.
        </div>
        {/* <div className="text-center md:text-left">
          <button className="border-2 border-blue-400 rounded-full text-blue-400 px-3 py-2">
            Read more
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ThirdSection;
